// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pickem/setup-preview.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePickemSetupPreviewBody,
  typePickemSetupPreviewOutput200,
} from "../../sdk/pickem/postPickemSetupPreview";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPickemSetupPreviewQueryKey(
  payload: typePickemSetupPreviewBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueKey:${JSON.stringify(payload.leagueKey)}`);
  if (typeof payload.setup !== "undefined") {
    queryKeySegments.push(`setup:${JSON.stringify(payload.setup)}`);
  }
  return [
    "post:pickem:pickemSetupPreview",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePickemSetupPreviewOutput200,
    unknown,
    typePickemSetupPreviewOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePickemSetupPreview(
  payload: typePickemSetupPreviewBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPickemSetupPreviewQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPickemSetupPreview(payload),
    ...resolvedOptions,
  });
}
